import { definePlatformAPI, } from '../../common';
export const platformAPICreator = definePlatformAPI((superAPI) => {
    // @ts-expect-error
    return (context) => {
        return {
            refComponents: {
                show: (widgetRef, selector) => superAPI.refComponents.showBySelector(widgetRef, selector),
                hide: (widgetRef, selector) => superAPI.refComponents.hideBySelector(widgetRef, selector),
                isHidden: (widgetRef, selector) => superAPI.refComponents.isHiddenBySelector(widgetRef, selector),
                getHiddenComponentRoles: (widgetRef, options) => superAPI.refComponents.getHiddenComponentRoles(widgetRef, options),
                findComponentBySelector: (widgetRef, selector) => superAPI.refComponents.findComponentBySelector(widgetRef, selector),
            },
        };
    };
});
//# sourceMappingURL=refComponents.panel-builder.v2.js.map